// extracted by mini-css-extract-plugin
module.exports = {"completeIssueModel":"style_completeIssueModel__3vG6M"};